import { AuthResponse, User } from '@/features/auth/types';

export const saveSuccessAuth = (data: AuthResponse) => {
  const access_token = data.access_token;
  const restUser = data.user;

  localStorage.setItem('token', access_token);
  localStorage.setItem('user', JSON.stringify(restUser));
};

export const clearSuccessAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getAuthToken = () => {
  return localStorage?.getItem('token');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');

  if (!user) {
    return null;
  }

  return JSON.parse(user) as User;
};
